/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const setPinnedGroupsBodyGroupUuidsMax = 50;

export const SetPinnedGroupsBody = zod.object({
  groupUuids: zod
    .array(zod.uuid())
    .max(setPinnedGroupsBodyGroupUuidsMax)
    .describe(
      "The groups to pin, in rail order, replacing the current list; at most 50. Groups the user isn't in are left out, and a repeat counts once. An empty list pins nothing.",
    ),
});

export type SetPinnedGroupsBody = zod.input<typeof SetPinnedGroupsBody>;
export type SetPinnedGroupsBodyOutput = zod.output<typeof SetPinnedGroupsBody>;
